const wrapper = "_35sw1h9xdfm";
const indicator = "_35si1iq1j4h";
const bulletIcon = "_35sbpqsxbb";

export { bulletIcon, indicator, wrapper };
import "./atom.indicator.style.linaria.module.css";
//# sourceMappingURL=atom.indicator.style.js.map
